import { render, staticRenderFns } from "./SectionInstructorsImg.vue?vue&type=template&id=d4a13008&scoped=true"
import script from "./SectionInstructorsImg.vue?vue&type=script&lang=js"
export * from "./SectionInstructorsImg.vue?vue&type=script&lang=js"
import style0 from "./SectionInstructorsImg.vue?vue&type=style&index=0&id=d4a13008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a13008",
  null
  
)

export default component.exports